import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
import * as Sentry from '@sentry/react';

// Sentry frontend (opcional: sólo si se define DSN)
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN as string | undefined;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: (process.env.REACT_APP_ENV as string) || process.env.NODE_ENV,
    tracesSampleRate: 0.05,
    integrations: [
      // Sentry v8: tracing integrado en @sentry/react
      Sentry.browserTracingIntegration(),
    ],
  });
  if (process.env.NODE_ENV !== 'production') {
    (window as any).__testSentry = () =>
      Sentry.captureException(new Error('Sentry front manual ' + Date.now()));
  }
}

// Silenciar logs ruidosos en producción
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
  // eslint-disable-next-line no-console
  console.debug = () => {};
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
